import { apiMotosSnop } from '@auteco/enviroment/apiMotosSnop'
import { loaderService } from './loaderService'

const getToken = () =>
  JSON.parse(sessionStorage.getItem('userInfo')).token || null

// ROLES

const getRolUser = async () => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.get('/backend/roles/iam', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getUsersToConfig = async () => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.get('/backend/roles/usuarios', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const deleteRolUserConfig = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.delete(
      `/backend/roles/usuarios?usuario_id=${params.userId}&rol_id=${params.rolId}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postRolUserConfig = async ({ params }) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/backend/roles/usuarios',
      params,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

// DESVIACIONES

const getDesviacionCombinada = async () => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.get('/v1/desviacion_combinada', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getDesviacionCombinadaNS = async (nivelServicio, modeloPlaneacion) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.get(
      `/v1/desviacion_combinada_ns?nivel_servicio=${nivelServicio}&modelo_planeacion=${encodeURIComponent(
        modeloPlaneacion,
      )}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const updateDesviacionCombinadaNS = async (editedNSData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      '/v1/desviacion_combinada',
      editedNSData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getMaestraModelos = async () => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.get(
      '/v1/desviacion_combinada/maestra_modelos',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

// INPUTS FINANCIEROS

const getTasaDescuento = async () => {
  try {
    const response = await apiMotosSnop.get(
      '/v1/desviacion_combinada/inputs_financieros/tasa_desc',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const updateTasaDescuento = async (tasaDescuentoAnual) => {
  try {
    const response = await apiMotosSnop.post(
      '/v1/desviacion_combinada/inputs_financieros/tasa_desc',
      { tasa_descuento_anual: tasaDescuentoAnual },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getCostoAlmacenamiento = async () => {
  try {
    const response = await apiMotosSnop.get(
      '/v1/desviacion_combinada/inputs_financieros/costo_almac',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const updateCostoAlmacenamiento = async (costoPorMetroCuadrado) => {
  try {
    const response = await apiMotosSnop.post(
      '/v1/desviacion_combinada/inputs_financieros/costo_almac',
      { costo_por_metro_cuadrado: costoPorMetroCuadrado },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

// LEADTIME

const getLeadtimeData = async () => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.get('/v1/leadtime_bq', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

// CALENDARIO FESTIVOS

const getCalendarioFestivos = async (pais = 'co', anio = '2025') => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.get(
      `/v1/festivos?pais=${pais}&anio=${anio}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const saveCalendarioFestivo = async (festivoData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post('/v1/festivos', festivoData, {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const saveCalendarioFestivoRango = async (festivoData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/festivos_rango',
      festivoData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const eliminarFestivo = async (id) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.delete(
      `/v1/festivos/eliminar?id=${id}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: 'Festivo eliminado exitosamente',
      }
    }
    return {
      success: false,
      message: 'Error al eliminar el festivo',
    }
  } catch (error) {
    console.error('Error eliminando festivo:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al eliminar festivo',
    }
  } finally {
    loaderService.hide()
  }
}

const eliminarFestivoRango = async (pais, fechaInicio, fechaFin) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.delete(
      `/v1/festivos/eliminar_rango?pais=${pais}&fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: 'Festivos eliminados exitosamente',
      }
    }
    return {
      success: false,
      message: 'Error al eliminar los festivos',
    }
  } catch (error) {
    console.error('Error eliminando festivos por rango:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al eliminar festivos',
    }
  } finally {
    loaderService.hide()
  }
}

const getConfigModelos = async () => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.get('/v1/configuracion_modelos', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const aplicarConsignaciones = async (consignacionData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      '/v1/configuracion_modelos/consignacion',
      consignacionData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const actualizarEstadoModelo = async (modeloPlaneacion, estado) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      '/v1/configuracion_modelos/estado',
      {
        modelo_planeacion: modeloPlaneacion,
        estado,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: `Estado del modelo "${modeloPlaneacion}" actualizado exitosamente a "${estado}"`,
      }
    }
    return {
      success: false,
      message: 'Error al actualizar el estado del modelo',
    }
  } catch (error) {
    console.error('Error actualizando estado del modelo:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al actualizar el estado del modelo',
    }
  } finally {
    loaderService.hide()
  }
}

// COMPRAS

const getModelos = async (compania = 'ASAS') => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.get(
      `/v1/compra/inventario_modelo/modelos_compania?compania=${encodeURIComponent(
        compania,
      )}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getInventariosByModelo = async (
  modeloPlaneacion,
  prototipos = false,
  segundas = false,
) => {
  loaderService.show()
  try {
    const params = new URLSearchParams({
      modelo_planeacion: modeloPlaneacion,
    })
    if (prototipos) {
      params.append('prototipos', 'true')
    }
    if (segundas) {
      params.append('segundas', 'true')
    }

    const response = await apiMotosSnop.get(
      `/v1/compra/inventarios?${params.toString()}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const buildProyectadoModeloParams = (
  modeloPlaneacion,
  escenario,
  periodo,
  prototipos,
  segundas,
) => {
  const params = new URLSearchParams({
    modelo_planeacion: modeloPlaneacion,
    escenario,
    tipo_periodo: periodo,
  })

  if (prototipos) {
    params.append('prototipos', 'true')
  }

  if (segundas) {
    params.append('segundas', 'true')
  }

  return params
}

const getInventarioProyectadoByModelo = async (
  modeloPlaneacion,
  escenario = 'inicial_2025_6',
  periodo = 'mes',
  prototipos = false,
  segundas = false,
) => {
  loaderService.show()
  try {
    const params = buildProyectadoModeloParams(
      modeloPlaneacion,
      escenario,
      periodo,
      prototipos,
      segundas,
    )

    const response = await apiMotosSnop.get(
      `/v1/compra/inventario_modelo/proyectado?${params.toString()}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getInventarioCompaniaProyectado = async (
  compania,
  tipoPeriodo = 'mes',
  escenario = 'inicial_2025_6',
  segmento = '',
  estado = 'nuevo',
) => {
  loaderService.show()
  try {
    // Convertir arrays a strings separados por comas si es necesario
    const segmentoParam = Array.isArray(segmento)
      ? segmento.join(',')
      : segmento
    const estadoParam = Array.isArray(estado) ? estado.join(',') : estado

    const url = `/v1/compra/inventario_compania/proyectado?compania=${encodeURIComponent(
      compania,
    )}&tipo_periodo=${encodeURIComponent(
      tipoPeriodo,
    )}&escenario=${encodeURIComponent(escenario)}&segmento=${encodeURIComponent(
      segmentoParam,
    )}&estado=${encodeURIComponent(estadoParam)}`

    const response = await apiMotosSnop.get(url, {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postInventarioCompaniaProyectado = async (
  compania,
  tipoPeriodo = 'mes',
  escenario = 'inicial_2025_6',
  segmento = '',
  estado = null,
  prototipos = false,
  segundas = false,
) => {
  loaderService.show()
  try {
    // Convertir arrays a strings separados por comas si es necesario
    const segmentoParam = Array.isArray(segmento)
      ? segmento.join(', ')
      : segmento

    const body = {
      compania,
      tipo_periodo: tipoPeriodo,
      escenario,
      segmento: segmentoParam || null,
      estado: Array.isArray(estado) ? estado.join(', ') : estado || null,
      prototipos,
      segundas,
    }

    const response = await apiMotosSnop.post(
      '/v1/compra/inventario_compania/proyectado',
      body,
      {
        headers: {
          Origin: 'https://lucia.com.co',
          Authorization: `${getToken()}`,
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const calcularGuardarInventarioMensual = async (
  modeloPlaneacion,
  nivelServicio,
  mesLlegada,
  escenario,
) => {
  loaderService.show()
  try {
    // mandar info por boy
    const response = await apiMotosSnop.post(
      '/v1/compra/inventarios_modelo/orquestador/calcular_guardar',
      {
        modelo_planeacion: modeloPlaneacion,
        dias_inventario: nivelServicio,
        mes_llegada: mesLlegada,
        escenario,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const modificarSellIn = async (sellInData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      'v1/compra/inventario_modelo/orquestador/sell_in',
      sellInData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const modificarSellInDirecto = async (sellInData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      'v1/compra/inventario_modelo/orquestador/sell_in',
      sellInData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        message: response.data.message || 'Sell In modificado exitosamente',
        data: response.data,
      }
    }
    return {
      success: false,
      message: 'Error al modificar Sell In',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al modificar Sell In',
    }
  } finally {
    loaderService.hide()
  }
}

const modificarSellInTecnoSuper = async (payload) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      'v1/compra/sell_in_tecnosuper',
      payload,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        message:
          response.data?.message ||
          'Sell In Tecnosuper actualizado correctamente',
        data: response.data,
      }
    }
    return {
      success: false,
      message:
        response.data?.message || 'Error al actualizar Sell In Tecnosuper',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al actualizar Sell In Tecnosuper',
    }
  } finally {
    loaderService.hide()
  }
}

const modificarSellOutTecnoSuper = async (payload) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      'v1/compra/sell_out_tecnosuper',
      payload,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        message:
          response.data?.message ||
          'Sell Out Tecnosuper actualizado correctamente',
        data: response.data,
      }
    }
    return {
      success: false,
      message:
        response.data?.message || 'Error al actualizar Sell Out Tecnosuper',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al actualizar Sell Out Tecnosuper',
    }
  } finally {
    loaderService.hide()
  }
}

const sellInMultiple = async (payload) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      'v1/compra/inventario_modelo/orquestador/sell_in_multiple',
      payload,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        message:
          response.data?.message || 'Sell in múltiple aplicado correctamente',
        data: response.data,
      }
    }
    return {
      success: false,
      message: response.data?.message || 'Error al aplicar sell in múltiple',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al aplicar sell in múltiple',
    }
  } finally {
    loaderService.hide()
  }
}

const sellInTecnoSuperMultiple = async (payload) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      'v1/compra/inventario_modelo/orquestador/sell_in_tecnosuper_multiple',
      payload,
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        message:
          response.data?.message ||
          'Sell In Tecnosuper múltiple aplicado correctamente',
        data: response.data,
      }
    }
    return {
      success: false,
      message:
        response.data?.message ||
        'Error al aplicar Sell In Tecnosuper múltiple',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al aplicar Sell In Tecnosuper múltiple',
    }
  } finally {
    loaderService.hide()
  }
}

const licitacionMultiple = async (payload) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      'v1/compra/inventario_modelo/orquestador/licitacion_multiple',
      payload,
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        message:
          response.data?.message ||
          'Licitación múltiple aplicada correctamente',
        data: response.data,
      }
    }
    return {
      success: false,
      message: response.data?.message || 'Error al aplicar licitación múltiple',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al aplicar licitación múltiple',
    }
  } finally {
    loaderService.hide()
  }
}

const sellOutTecnoSuperMultiple = async (payload) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      'v1/compra/inventario_modelo/orquestador/sell_out_tecnosuper_multiple',
      payload,
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        message:
          response.data?.message ||
          'Sell Out Tecnosuper múltiple aplicado correctamente',
        data: response.data,
      }
    }
    return {
      success: false,
      message:
        response.data?.message ||
        'Error al aplicar Sell Out Tecnosuper múltiple',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al aplicar Sell Out Tecnosuper múltiple',
    }
  } finally {
    loaderService.hide()
  }
}

const getComentarios = async (modeloPlaneacion, escenario = 'inicial') => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/compra/inventario_modelo/comentarios/obtener',
      {
        modelo_planeacion: modeloPlaneacion,
        escenario,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const crearComentario = async (comentarioData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/compra/inventario_modelo/comentarios',
      comentarioData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getLlegadas = async (
  modeloPlaneacion,
  escenario = 'inicial',
  tipoPeriodo = 'mes',
) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.get(
      `/v1/compra/inventario_modelo/llegadas?modelo_planeacion=${encodeURIComponent(
        modeloPlaneacion,
      )}&escenario=${escenario}&tipo_periodo=${tipoPeriodo}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const modificarFechaLlegada = async (fechaData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      '/v1/compra/inventario_modelo/fecha_llegada',
      fechaData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const calcularDesviacionCombinada = async () => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      '/v1/desviacion_combinada/calcular',
      {},
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getResumenCompra = async (
  escenario = 'inicial_2025_6',
  compania = 'ASAS',
  soloCompra = true,
  prototipos = false,
  segundas = false,
) => {
  loaderService.show()
  try {
    const soloCompraParam = `&solo_compra=${soloCompra}`
    const prototiposParam = prototipos ? '&prototipos=true' : ''
    const segundasParam = segundas ? '&segundas=true' : ''
    const response = await apiMotosSnop.get(
      `/v1/compra_general/informacion?escenario=${encodeURIComponent(
        escenario,
      )}&compania=${encodeURIComponent(
        compania,
      )}${soloCompraParam}${prototiposParam}${segundasParam}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getEscenariosCompra = async (compania = 'TVS') => {
  console.log('compania:', compania)
  loaderService.show()
  try {
    const response = await apiMotosSnop.get(
      `/v1/compra_general/escenarios?compania=${encodeURIComponent(compania)}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const crearEscenarioCompra = async (escenarioData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/compra_general/escenario',
      escenarioData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const eliminarEscenarioCompra = async (escenario, compania = 'ASAS') => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.delete(`/v1/compra_general/escenario`, {
      headers: {
        Authorization: `${getToken()}`,
      },
      data: {
        escenario_base: escenario,
        compania,
      },
    })
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const calcularGuardarInventarioCompania = async (compania, escenario) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/compra/inventarios_modelo/orquestador/compania/calcular_guardar',
      {
        compania,
        escenario,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        message:
          response.data.message ||
          'Escenario calculado y guardado exitosamente',
        data: response.data,
      }
    }
    return {
      success: false,
      message: 'Error al calcular y guardar el escenario',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al calcular y guardar el escenario',
    }
  } finally {
    loaderService.hide()
  }
}

const eliminarEscenarioPorModelo = async (
  escenario,
  compania,
  modeloPlaneacion,
) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.delete(
      '/v1/compra_general/escenario/por_modelo',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
        data: {
          escenario_base: escenario,
          compania,
          modelo_planeacion: modeloPlaneacion,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        message:
          response.data.message ||
          'Escenario eliminado exitosamente para el modelo',
        data: response.data,
      }
    }
    return {
      success: false,
      message: 'Error al eliminar el escenario para el modelo',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al eliminar el escenario para el modelo',
    }
  } finally {
    loaderService.hide()
  }
}

const calcularGuardarInventarioPorModelo = async (
  modeloPlaneacion,
  escenario,
  diasInventario = '',
  mesLlegada = '',
) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/compra/inventarios_modelo/orquestador/calcular_guardar',
      {
        modelo_planeacion: modeloPlaneacion,
        dias_inventario: diasInventario,
        mes_llegada: mesLlegada,
        escenario,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        message:
          response.data.message ||
          'Inventario calculado y guardado exitosamente para el modelo',
        data: response.data,
      }
    }
    return {
      success: false,
      message: 'Error al calcular y guardar el inventario para el modelo',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al calcular y guardar el inventario para el modelo',
    }
  } finally {
    loaderService.hide()
  }
}

const getContrasteEscenarios = async (escenarioA, escenarioB, tipoNegocio) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      `/v1/compra_general/contraste_escenarios`,
      {
        escenarioA,
        escenarioB,
        compania: tipoNegocio,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const compraEnFirme = async (escenario, compania = 'ASAS', segmentos = []) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/compra_general/compra_en_firme',
      {
        escenario,
        compania,
        segmentos,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: 'Compra en firme procesada exitosamente',
      }
    }
    return {
      success: false,
      message: 'Error al procesar la compra en firme',
    }
  } catch (error) {
    console.error('Error en compra en firme:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al procesar la compra en firme',
    }
  } finally {
    loaderService.hide()
  }
}

const actualizarCargabilidadCompra = async (
  modeloPlaneacion,
  cargabilidad,
  compania,
  escenario,
) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      '/v1/compra/cargabilidad',
      {
        modelo_planeacion: modeloPlaneacion,
        cargabilidad,
        compania,
        escenario,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: `Cargabilidad del modelo "${modeloPlaneacion}" actualizada exitosamente a ${cargabilidad}`,
      }
    }
    return {
      success: false,
      message: 'Error al actualizar la cargabilidad',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al actualizar la cargabilidad',
    }
  } finally {
    loaderService.hide()
  }
}

const setEscenarioCaracteristica = async ({
  escenario,
  compania,
  caracteristica,
  activo,
}) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/compra/escenario/caracteristica',
      {
        escenario,
        compania,
        caracteristica,
        activo,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return {
        success: true,
        data: response.data,
        message:
          response.data?.message ||
          (activo
            ? 'Optimización tecno super activada'
            : 'Optimización tecno super desactivada'),
      }
    }
    return {
      success: false,
      message: 'Error al actualizar la característica del escenario',
    }
  } catch (error) {
    console.error('Error al actualizar característica del escenario:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al actualizar la característica del escenario',
    }
  } finally {
    loaderService.hide()
  }
}

const importarLeadtime = async (file) => {
  loaderService.show()
  try {
    const formData = new FormData()
    formData.append('file', file)

    const response = await apiMotosSnop.post('/v1/leadtime', formData, {
      headers: {
        Authorization: `${getToken()}`,
        'Content-Type': 'multipart/form-data',
      },
    })

    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: 'Archivo de leadtime importado exitosamente',
      }
    }
    return {
      success: false,
      message: 'Error al importar el archivo de leadtime',
    }
  } catch (error) {
    console.error('Error importando leadtime:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al importar el archivo de leadtime',
    }
  } finally {
    loaderService.hide()
  }
}

const importarUtilidadPorMoto = async (file) => {
  loaderService.show()
  try {
    const formData = new FormData()
    formData.append('file', file)

    const response = await apiMotosSnop.post(
      '/v1/desviacion_combinada/utilidad_por_moto',
      formData,
      {
        headers: {
          Authorization: `${getToken()}`,
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: 'Archivo de utilidad por moto importado exitosamente',
      }
    }
    return {
      success: false,
      message: 'Error al importar el archivo de utilidad por moto',
    }
  } catch (error) {
    console.error('Error importando utilidad por moto:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al importar el archivo de utilidad por moto',
    }
  } finally {
    loaderService.hide()
  }
}

const calcularLeadtime = async () => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/leadtime_bq_calcular',
      {},
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )

    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: 'Cálculo de leadtime ejecutado exitosamente',
      }
    }
    return {
      success: false,
      message: 'Error al ejecutar el cálculo de leadtime',
    }
  } catch (error) {
    console.error('Error calculando leadtime:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al calcular leadtime',
    }
  } finally {
    loaderService.hide()
  }
}

const modificarContenedores = async (contenedoresData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      '/v1/compra/inventario_modelo/contenedores',
      contenedoresData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )

    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: 'Contenedores modificados exitosamente',
      }
    }
    return {
      success: false,
      message: 'Error al modificar los contenedores',
    }
  } catch (error) {
    console.error('Error modificando contenedores:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al modificar contenedores',
    }
  } finally {
    loaderService.hide()
  }
}

const modificarLicitacion = async (licitacionData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/compra/licitaciones',
      licitacionData,
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
          'Content-Type': 'application/json',
        },
      },
    )
    if (response.status === 200 || response.status === 201) {
      return {
        success: true,
        message: response.data.message || 'Licitación modificada exitosamente',
        data: response.data,
      }
    }
    return {
      success: false,
      message: 'Error al modificar licitación',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al modificar licitación',
    }
  } finally {
    loaderService.hide()
  }
}

// ACTUALIZAR CARGABILIDAD
const actualizarCargabilidadModelo = async (modeloPlaneacion, cargabilidad) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      '/v1/configuracion_modelos/cargabilidad',
      {
        modelo_planeacion: modeloPlaneacion,
        cargabilidad,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: `Cargabilidad del modelo "${modeloPlaneacion}" actualizada exitosamente a ${cargabilidad}`,
      }
    }
    return {
      success: false,
      message: 'Error al actualizar la cargabilidad',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al actualizar la cargabilidad',
    }
  } finally {
    loaderService.hide()
  }
}

// ACTUALIZAR CARGABILIDAD
const actualizarOrdenModelo = async (modeloPlaneacion, orden) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      '/v1/configuracion_modelos/orden',
      {
        datos: {
          modelo_planeacion: modeloPlaneacion,
          orden,
        },
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: `Orden del modelo "${modeloPlaneacion}" actualizada exitosamente a ${orden}`,
      }
    }
    return {
      success: false,
      message: 'Error al actualizar la orden',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al actualizar la orden',
    }
  } finally {
    loaderService.hide()
  }
}

// ACTUALIZAR DÍAS INVENTARIO
const actualizarDiasInventarioModelo = async (
  modeloPlaneacion,
  diasInventario,
) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      '/v1/configuracion_modelos/dias_inventario',
      {
        modelo_planeacion: modeloPlaneacion,
        dias_inventario: diasInventario,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: `Días de inventario del modelo "${modeloPlaneacion}" actualizados exitosamente a ${diasInventario}`,
      }
    }
    return {
      success: false,
      message: 'Error al actualizar los días de inventario',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al actualizar los días de inventario',
    }
  } finally {
    loaderService.hide()
  }
}

// get proovedores

const getProveedores = async () => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.get(
      '/v1/configuracion_modelos/proveedores',
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

// CREAR MODELO PLANEACION

const crearModeloPlaneacion = async (modeloPlaneacionData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/configuracion_modelos/crear_modelo',
      modeloPlaneacionData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

// ELIMINAR MODELO PLANEACION

const eliminarModeloPlaneacion = async (modeloPlaneacion) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.delete(
      `/v1/configuracion_modelos/eliminar_modelo?modelo_planeacion=${modeloPlaneacion}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getInventarioComentarios = async (modeloPlaneacion, escenario) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/compra/inventario_modelo/comentarios/obtener',
      {
        modelo_planeacion: modeloPlaneacion,
        escenario,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const putAsignarComentario = async (comentarioData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/compra/inventario_modelo/comentarios',
      comentarioData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const putInclusionLlegadasModelo = async (modeloPlaneacion) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      '/v1/configuracion_modelos/inclusion_llegadas',
      {
        modelo_planeacion: modeloPlaneacion,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getInclusionLlegadasModelo = async (dataModelo) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      `/v1/compra/inventario_modelo/inclusion_llegadas`,
      dataModelo,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const actualizarFOB = async (modeloPlaneacion, fob) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/compra_general/fob',
      {
        modelo_planeacion: modeloPlaneacion,
        fob: parseFloat(fob),
      },
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: 'FOB actualizado exitosamente',
      }
    }
    return {
      success: false,
      message: 'Error al actualizar el FOB',
    }
  } catch (error) {
    console.error('Error actualizando FOB:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al actualizar el FOB',
    }
  } finally {
    loaderService.hide()
  }
}

const getCongelarFechaEstado = async () => {
  try {
    const response = await apiMotosSnop.get('/v1/compra/congelar_fecha', {
      headers: {
        Authorization: `${getToken()}`,
        Origin: 'https://lucia.com.co',
      },
    })
    if (response.status === 200 && response.data?.success) {
      const puedeCongelar = response.data.success.puede_congelar === 1
      return { success: true, puedeCongelar }
    }
    return { success: true, puedeCongelar: false }
  } catch (error) {
    return { success: false, puedeCongelar: false }
  }
}

const congelarFecha = async () => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/compra/congelar_fecha',
      {},
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: 'Congelación realizada exitosamente',
      }
    }
    return {
      success: false,
      message: 'Error al congelar fecha',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message || 'Error de conexión al congelar fecha',
    }
  } finally {
    loaderService.hide()
  }
}

const actualizarLlegadas = async (compania = 'TVS', descripcion = '') => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/compra_general/escenario_actualizado',
      {
        compania,
        descripcion,
      },
      {
        headers: {
          Authorization: `${getToken()}`,
          Origin: 'https://lucia.com.co',
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Llegadas actualizadas exitosamente',
      }
    }
    return {
      success: false,
      message: 'Error al actualizar las llegadas',
    }
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al actualizar las llegadas',
    }
  } finally {
    loaderService.hide()
  }
}

// ADMIN MODELOS APLICACION

const getAdminModelosAplicacion = async () => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.get('/v1/admin_modelos_aplicacion', {
      headers: {
        Authorization: `${getToken()}`,
      },
    })
    if (response.status === 200) {
      return {
        success: true,
        data: response.data.success || [],
      }
    }
    return {
      success: false,
      message: 'Error al obtener los modelos de aplicación',
    }
  } catch (error) {
    console.error('Error obteniendo modelos de aplicación:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al obtener modelos de aplicación',
    }
  } finally {
    loaderService.hide()
  }
}

const crearAdminModeloAplicacion = async (modeloData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.post(
      '/v1/admin_modelos_aplicacion',
      modeloData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: 'Modelo de aplicación creado exitosamente',
      }
    }
    return {
      success: false,
      message: 'Error al crear el modelo de aplicación',
    }
  } catch (error) {
    console.error('Error creando modelo de aplicación:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al crear modelo de aplicación',
    }
  } finally {
    loaderService.hide()
  }
}

const actualizarAdminModeloAplicacion = async (modeloData) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.put(
      '/v1/admin_modelos_aplicacion',
      modeloData,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: 'Modelo de aplicación actualizado exitosamente',
      }
    }
    return {
      success: false,
      message: 'Error al actualizar el modelo de aplicación',
    }
  } catch (error) {
    console.error('Error actualizando modelo de aplicación:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al actualizar modelo de aplicación',
    }
  } finally {
    loaderService.hide()
  }
}

const eliminarAdminModeloAplicacion = async (id) => {
  loaderService.show()
  try {
    const response = await apiMotosSnop.delete('/v1/admin_modelos_aplicacion', {
      headers: {
        Authorization: `${getToken()}`,
      },
      data: {
        id_modelo_planeacion: id,
      },
    })
    if (response.status === 200) {
      return {
        success: true,
        data: response.data,
        message: 'Modelo de aplicación eliminado exitosamente',
      }
    }
    return {
      success: false,
      message: 'Error al eliminar el modelo de aplicación',
    }
  } catch (error) {
    console.error('Error eliminando modelo de aplicación:', error)
    return {
      success: false,
      message:
        error.response?.data?.message ||
        'Error de conexión al eliminar modelo de aplicación',
    }
  } finally {
    loaderService.hide()
  }
}

const getEscenariosCompraEnFirme = async (
  modeloPlaneacion,
  tipoPeriodo = 'mes',
) => {
  loaderService.show()
  try {
    const params = new URLSearchParams({
      modelo_planeacion: modeloPlaneacion,
      tipo_periodo: tipoPeriodo,
    })
    const response = await apiMotosSnop.get(
      `/v1/compra/inventario_modelo/escenarios_con_compra_en_firme?${params.toString()}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getGraficoDiferencialSellIn = async (
  modeloPlaneacion,
  escenarioBase,
  escenarioComparativo,
  tipoPeriodo = 'mes',
  anioBase,
) => {
  loaderService.show()
  try {
    const params = new URLSearchParams({
      modelo_planeacion: modeloPlaneacion,
      escenario_base: escenarioBase,
      escenario_comparativo: escenarioComparativo,
      tipo_periodo: tipoPeriodo,
      anio_base: String(anioBase),
    })
    const response = await apiMotosSnop.get(
      `/v1/compra/inventario_modelo/grafico_diferencial_sell_in?${params.toString()}`,
      {
        headers: {
          Authorization: `${getToken()}`,
        },
      },
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

export {
  getDesviacionCombinada,
  getDesviacionCombinadaNS,
  updateDesviacionCombinadaNS,
  getRolUser,
  getUsersToConfig,
  postRolUserConfig,
  deleteRolUserConfig,
  getMaestraModelos,
  getTasaDescuento,
  updateTasaDescuento,
  getCostoAlmacenamiento,
  updateCostoAlmacenamiento,
  getLeadtimeData,
  importarLeadtime,
  importarUtilidadPorMoto,
  calcularLeadtime,
  getCalendarioFestivos,
  saveCalendarioFestivo,
  saveCalendarioFestivoRango,
  eliminarFestivo,
  eliminarFestivoRango,
  getConfigModelos,
  aplicarConsignaciones,
  actualizarEstadoModelo,
  getModelos,
  getInventariosByModelo,
  getInventarioProyectadoByModelo,
  getInventarioCompaniaProyectado,
  postInventarioCompaniaProyectado,
  calcularGuardarInventarioMensual,
  modificarSellIn,
  modificarSellInDirecto,
  modificarSellInTecnoSuper,
  modificarSellOutTecnoSuper,
  sellInMultiple,
  sellInTecnoSuperMultiple,
  licitacionMultiple,
  sellOutTecnoSuperMultiple,
  getComentarios,
  crearComentario,
  getLlegadas,
  modificarFechaLlegada,
  modificarContenedores,
  calcularDesviacionCombinada,
  getResumenCompra,
  getEscenariosCompra,
  crearEscenarioCompra,
  eliminarEscenarioCompra,
  calcularGuardarInventarioCompania,
  eliminarEscenarioPorModelo,
  calcularGuardarInventarioPorModelo,
  getContrasteEscenarios,
  compraEnFirme,
  actualizarCargabilidadCompra,
  setEscenarioCaracteristica,
  actualizarCargabilidadModelo,
  actualizarDiasInventarioModelo,
  actualizarOrdenModelo,
  getProveedores,
  crearModeloPlaneacion,
  eliminarModeloPlaneacion,
  getInventarioComentarios,
  putAsignarComentario,
  putInclusionLlegadasModelo,
  getInclusionLlegadasModelo,
  actualizarFOB,
  getCongelarFechaEstado,
  congelarFecha,
  actualizarLlegadas,
  modificarLicitacion,
  getAdminModelosAplicacion,
  crearAdminModeloAplicacion,
  actualizarAdminModeloAplicacion,
  eliminarAdminModeloAplicacion,
  getEscenariosCompraEnFirme,
  getGraficoDiferencialSellIn,
}
